import { axiosInstance } from "../../config/axios";
import { AxiosError } from "axios";
import { useMutation } from "react-query";
import { GetUserMenuListResponse } from "./useGetUserMenuList";

export type GetUserMenusForRoleRequest = {
  roleId?: number;
};

async function getUserMenusForRole(
  data: GetUserMenusForRoleRequest
): Promise<GetUserMenuListResponse> {
  try {
    const params = data.roleId ? `?roleId=${data.roleId}` : '';
    return (await axiosInstance.get(`/RoleMenu/GetRoleMenus${params}`)).data;
  } catch (ex) {
    throw ((ex as AxiosError).response?.data as any).error;
  }
}

export function useGetUserMenusForRole() {
  return useMutation<GetUserMenuListResponse, Error, GetUserMenusForRoleRequest>(
    (variables) => getUserMenusForRole(variables)
  );
}
